import {
  Airplane,
  Baby,
  Bird,
  BowlFood,
  CarProfile,
  ChatText,
  Coffee,
  Compass,
  Cookie,
  Gauge,
  GlobeHemisphereWest,
  Heart,
  Horse,
  HouseLine,
  Island,
  Motorcycle,
  MusicNotes,
  PawPrint,
  PersonSimpleRun,
  PersonSimpleTaiChi,
  Plant,
  RoadHorizon,
  Screwdriver,
  Smiley,
  Snowflake,
  SoccerBall,
  Sparkle,
  Sunglasses,
  Train,
  Trophy,
  Users,
} from '@phosphor-icons/react'
import { ReactNode, useState } from 'react'

const FactsIconMap: { [key: string]: ReactNode } = {
  baby: <Baby size={24} weight="fill" className="text-blue-600" />,
  users: <Users size={24} weight="fill" className="text-blue-600" />,
  'bowl-food': <BowlFood size={24} weight="fill" className="text-blue-600" />,
  'person-simple-tai-chi': (
    <PersonSimpleTaiChi size={24} weight="fill" className="text-blue-600" />
  ),
  'music-notes': (
    <MusicNotes size={24} weight="fill" className="text-blue-600" />
  ),
  'car-profile': (
    <CarProfile size={24} weight="fill" className="text-blue-600" />
  ),
  bird: <Bird size={24} weight="fill" className="text-blue-600" />,
  smiley: <Smiley size={24} weight="fill" className="text-blue-600" />,
  cookie: <Cookie size={24} weight="fill" className="text-blue-600" />,
  'paw-print': <PawPrint size={24} weight="fill" className="text-blue-600" />,
  airplane: <Airplane size={24} weight="fill" className="text-blue-600" />,
  'globe-hemisphere-west': (
    <GlobeHemisphereWest size={24} weight="fill" className="text-blue-600" />
  ),
  trophy: <Trophy size={24} weight="fill" className="text-blue-600" />,
  coffee: <Coffee size={24} weight="fill" className="text-blue-600" />,
  gauge: <Gauge size={24} weight="fill" className="text-blue-600" />,
  motorcycle: <Motorcycle size={24} weight="fill" className="text-blue-600" />,
  sparkle: <Sparkle size={24} weight="fill" className="text-blue-600" />,
  heart: <Heart size={24} weight="fill" className="text-blue-600" />,
  screwdriver: (
    <Screwdriver size={24} weight="fill" className="text-blue-600" />
  ),
  'soccer-ball': (
    <SoccerBall size={24} weight="fill" className="text-blue-600" />
  ),
  island: <Island size={24} weight="fill" className="text-blue-600" />,
  sunglasses: <Sunglasses size={24} weight="fill" className="text-blue-600" />,
  'person-simple-run': (
    <PersonSimpleRun size={24} weight="fill" className="text-blue-600" />
  ),
  snowflake: <Snowflake size={24} weight="fill" className="text-blue-600" />,
  'road-horizon': (
    <RoadHorizon size={24} weight="fill" className="text-blue-600" />
  ),
  'chat-text': <ChatText size={24} weight="fill" className="text-blue-600" />,
  compass: <Compass size={24} weight="fill" className="text-blue-600" />,
  'house-line': <HouseLine size={24} weight="fill" className="text-blue-600" />,
  horse: <Horse size={24} weight="fill" className="text-blue-600" />,
  train: <Train size={24} weight="fill" className="text-blue-600" />,
  plant: <Plant size={24} weight="fill" className="text-blue-600" />,
}

const LocationList = ({
  locations,
}: {
  locations: { id: string; name: string }[]
}) => {
  const [isExpanded, setIsExpanded] = useState(false)
  const visibleLocations = isExpanded ? locations : locations.slice(0, 5)
  const hiddenCount = locations.length - visibleLocations.length

  return (
    <p>
      {visibleLocations.map((location) => location.name).join(', ')}
      {hiddenCount > 0 && (
        <>
          {' '}
          <button
            onClick={() => setIsExpanded(true)}
            className="text-purple-600"
          >
            +{hiddenCount} weitere
          </button>
        </>
      )}
    </p>
  )
}

const getColorFromString = (input: string) => {
  let hash = 0
  for (let i = 0; i < input.length; i++) {
    hash = hash + input.charCodeAt(i)
  }

  const index = Math.abs(hash) % FeedbackColors.length
  return FeedbackColors[index]
}

const FeedbackColors = [
  'bg-pink-600 text-white',
  'bg-red-600 text-white',
  'bg-blue-600 text-white',
  'bg-green-600 text-white',
  'bg-yellow-600 text-white',
]

export { FactsIconMap, getColorFromString, LocationList }
